import React from 'react';
import {
  makeStyles,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@material-ui/core"
import { DialogResponsive } from './DialogResponsive';
import { ImagineGrid as Grid } from '../../components'
import { useDispatch } from "react-redux"
import { infraStructureActions } from './../../actions';
import { useTranslation } from 'react-i18next';

const useStyle = makeStyles((theme) => ({
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  modalWrapper: {
    padding: "2rem",
    justifySelf: "center"
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  warningIcon: {
    color: "#FE9900",
    fontSize: 100,
  },
  button: {
    width: "100%"
  },
  titleWrapper: {
    display: "flex",
    justifyContent: "center",
  },
  title: {
    fontWeight: 600,
    font: 'normal normal 600 20px/30px Poppins',
  },
  description: {
    textAlign: "left",
    fontSize: 16
  }
}))

export const DialogDeleteInfra = ({ open, id, type, typeDialog, handleCloseDeleteInfra, name }) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  function handleNoButton() {
    handleCloseDeleteInfra()
  }

  function handleYesButton() {

    dispatch(infraStructureActions.deleteInfraStructure({ type, id }));

    setTimeout(() => {
      dispatch(infraStructureActions.getInfraStructure({ page: 1, limit: 10 }));
    }, 1000)

    handleCloseDeleteInfra();
  }

  return (
    <DialogResponsive open={open}>
      <DialogContent className={classes.content}>
        <Grid container spacing={4}>

          <Grid item className={classes.titleWrapper}>
            <Typography variant="subtitle1" component="h3" className={classes.title}>
              {t('deseja_excluir_a_infraestrutura')}

            </Typography>
          </Grid>
          <Grid item>

            <p className={classes.description}>{t('as_informacoes_sobre')}<b>{` ${name}`} </b>{t('serao_excluídas_permanentemente_e_ela_sera_desvinculada')}</p>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container spacing={4} cols={4}>
          <Grid item>
          </Grid>
          <Grid item>
          </Grid>
          <Grid item>
            <Button
              className={classes.button}
              variant="outlined"
              color="primary"
              onClick={handleNoButton}
            >
              {t('voltar')}
            </Button>
          </Grid>
          <Grid item>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              onClick={handleYesButton}
            >
              {t('excluir')}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </DialogResponsive>
  )
}
